import { Component } from '@angular/core';
import { BackgroundComponent } from '../../../shared/pages/background/background.component';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-logout',
  imports: [BackgroundComponent, RouterLink],
  templateUrl: './logout.component.html',
  styleUrl: './logout.component.css'
})
export class LogoutComponent {

}
